import "./vision-mission-value.scss";
import HeadlineSection from "../../components/headline-section";
import VissionCard from "../vision-card";
import vision from "../../assets/about/vision.png";
import mission from "../../assets/about/mision.png";
import value from "../../assets/about/value.png";


const VisionMissionValue = () => {
  return (
      <div className="our-vmv">
        <div>
          <HeadlineSection headline="الرؤى" secondHeadline="والقيم"/>
          <p className="headline-desc">لمؤسسة الشيخ محمد بن صالح الشاوي <br/> مجموعة من الرؤى والقيم التي نضعها دائما نصب أعيننا ومن أهمها</p>
        </div>
        
        <div className="all-vmv">
            <VissionCard visionImage={vision}
            visionTitle={"الرؤية"}
            visionDesc={"القيام بعمل مؤسسي يساهم في عطاء القطاع الخيري لتحقيق الأعظم أجراً والأكثر نفعاً "}
            />
            <VissionCard visionImage={mission}
            visionTitle={"الرسالة"}
            visionDesc={"مؤسسة خيري مانحة تتكامل مع غيرها في دعم أعمال الخير من خلال عمل مؤسسي متقن "}
            />
            <VissionCard visionImage={value}
            visionTitle={"القيم"}
            visionDesc={"الوضوح ,المبادرة ,النوعية العدل ,التحفيز ,التعاون "}
            />
        
        </div>
        
      </div>
  );
};

export default VisionMissionValue;